import baseAPI from '@/api';
import { RollCompetitionEntries } from '@/models/roll-competition/entries';
import { AxiosResponse } from 'axios';

export async function fetchCreateRollCompetitionEntrie(): Promise<RollCompetitionEntries> {
  const response: AxiosResponse<RollCompetitionEntries> =
    await baseAPI.post<RollCompetitionEntries>('/roll-competition-entries');
  return response.data;
}
